import { DOWN_ARROW, INSERT } from '@angular/cdk/keycodes';
import {
  AsyncPipe,
  DatePipe,
  Location,
  NgClass,
  NgFor,
  NgIf,
  NgSwitch,
  NgSwitchCase,
  NgSwitchDefault,
  NgTemplateOutlet,
} from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
  HostListener,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import {
  MatLegacySelect as MatSelect,
  MatLegacySelectModule as MatSelectModule,
} from '@angular/material/legacy-select';
import { MatLegacySnackBarModule, MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import {
  MatLegacyTab as MatTab,
  MatLegacyTabGroup as MatTabGroup,
  MatLegacyTabsModule as MatTabsModule,
} from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiLinks } from '@cutting/app.api-links';
import { AuthHelper } from '@cutting/main/shared/helper/auth.helper';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { ClientOptionService } from '@cutting/main/shared/services/client-options.service';
import { UserSettingsService } from '@cutting/main/shared/services/user-settings.service';
import { fuseAnimations } from '@fuse/animations';
import { HubConnection } from '@microsoft/signalr';
import {
  BazisMaterialHelper,
  CadModelMaterialType,
  CornerProcessingHelper,
  CountertopRequest,
  CuttingCadModel,
  CuttingCadModelMaterialLink,
  CuttingClientMaterial,
  CuttingClientOptions,
  CuttingEngine,
  CuttingFacade,
  CuttingFacadeMaterial,
  CuttingFileSettingsSyncDate,
  CuttingHoleDiameters,
  CuttingMatBaseGroup,
  CuttingMaterial,
  CuttingOrderDetail,
  CuttingOrderQuestion,
  CuttingPanel,
  CuttingPanelHelper,
  CuttingPaySystemInfo,
  CuttingPaySystemType,
  CuttingPointOfIssue,
  CuttingSettings,
  CuttingTask,
  DefaultCuttingOrderStatusNamePipe,
  DeliveryTypeEnum,
  Estimate,
  EventManagerService,
  ExtendedAddress,
  GroupMaterialDiscountTreeDialogComponent,
  ICustomResponse,
  ICuttingBaseMaterial,
  LegacyDialogsService,
  LoadingState,
  MatBaseGroupDiscount,
  MaterialBaseService,
  MaterialType,
  MyValidator,
  NgxLocalizedNumbers,
  OrderModelsComponent,
  OrderModelsModule,
  OrderModelsService,
  OrderStatusAction,
  OverlayLoaderModule,
  PipesModule,
  PresetSettings,
  ProductProcessingMode,
  StateCuttingTaskEnum,
  TypeGroupMaterial,
  connectToGroup,
  mapBusinessObjectsToRequest,
  startConnection,
} from 'cloud-shared-lib';
import * as _ from 'lodash';
import { Observable, Subject, firstValueFrom, forkJoin, from, lastValueFrom, of } from 'rxjs';
import {
  catchError,
  concatMap,
  debounceTime,
  filter,
  finalize,
  first,
  map,
  share,
  skip,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs/operators';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ClientMaterialService } from '@cutting/main/shared/services/client-material.service';
import { FuseDirectivesModule } from '@fuse/directives/directives';
import { ChatMessage } from 'projects/cloud-shared-lib/src/lib/components/support-chat/models/support-chat.message.model';
import { SupportChatComponent } from 'projects/cloud-shared-lib/src/lib/components/support-chat/support-chat.component';
import { FacadesComponent } from '../facades/facades.component';
import { AddToRemoteCartResDialogComponent } from './add-to-remote-cart-res-dialog/add-to-remote-cart-res-dialog.component';
import { ClientMaterialsComponent } from './client-materials/client-materials.component';
import { CountertopsComponent } from './countertops/countertops.component';
import { CutHistoryComponent } from './cut-history/cut-history.component';
import { CuttingResultComponent } from './cutting-result/cutting-result.component';
import { EstimateComponent } from './estimate/estimate.component';
import { FurnitureListComponent } from './furniture-list/furniture-list.component';
import { MaterialsComponent } from './material/materials.component';
import { OrderDetailModule } from './order-detail.module';
import { AddOrderToRemoteCartResponse, OrderDetailService } from './order-detail.service';
import { OrderDocumentsComponent } from './order-documents/order-documents.component';
import { OrderQuestionChatComponent } from './order-question/order-question-chat.component';
import { OrderQuestionChatService } from './order-question/order-question-chat.service';
import { OrderRemarkDialogComponent } from './order-remark-dialog/order-remark-dialog.component';
import { PaymentsService } from './payments/payments.service';
import { PaypalPayDialogComponent } from './payments/paypal-pay-dialog/paypal-pay-dialog.component';
import { PsbPayDialogComponent } from './payments/psb-pay-dialog/psb-pay-dialog.component';
import { WooppayPayDialogComponent } from './payments/wooppay-pay-dialog/wooppay-pay-dialog.component';
import { PointsOfIssueDialogComponent } from './points-of-issue-dialog/points-of-issue-dialog.component';
import {
  ElasticModelListComponent,
  ElasticModelListComponent as ProductListComponent,
} from './products-list/products-list.component';

@Component({
  selector: 'cutting-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    NgTemplateOutlet,
    NgClass,
    AsyncPipe,
    DatePipe,
    OverlayLoaderModule,
    OrderDetailModule,
    PipesModule,
    NgxLocalizedNumbers,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatBadgeModule,
    MatButtonModule,
    MatTooltipModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatLegacySnackBarModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    ElasticModelListComponent,
    OrderDocumentsComponent,
    MaterialsComponent,
    FurnitureListComponent,
    EstimateComponent,
    ClientMaterialsComponent,
    CutHistoryComponent,
    CuttingResultComponent,
    FacadesComponent,
    CountertopsComponent,
    OrderModelsModule,
    FuseDirectivesModule,
    SupportChatComponent,
    MatSnackBarModule,
    OrderQuestionChatComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    OrderDetailService,
    PaymentsService,
    { provide: OrderModelsService, useExisting: OrderDetailService },
    OrderQuestionChatService,
  ],
  animations: fuseAnimations,
})
export class OrderDetailComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('materials', { static: false }) materialsComponent: MaterialsComponent;
  @ViewChild('facades', { static: false }) facadesComponent: FacadesComponent;
  @ViewChild('countertops', { static: false }) countertopsComponent: CountertopsComponent;
  @ViewChild('cuttingResult', { static: false }) cuttingResult: CuttingResultComponent;
  @ViewChild('orderFiles', { static: false }) orderFiles: OrderModelsComponent;
  @ViewChild('orderProductList', { static: false }) orderProductList: ProductListComponent;
  @ViewChild('tabGroup', { static: false }) tabGroup: MatTabGroup;
  @ViewChild('modelsTab', { static: false }) modelsTab: MatTab;
  @ViewChild('materialsTab', { static: false }) materialsTab: MatTab;
  @ViewChild('cuttingResultTab', { static: false }) cuttingResultTab: MatTab;
  @ViewChild('orderEstimateTab', { static: false }) orderEstimateTab: MatTab;
  @ViewChild('cutHistoryTab', { static: false }) cutHistoryTab: MatTab;
  @ViewChild('questionTab', { static: false }) questionTab: MatTab;
  @ViewChild('orderFurniture', { static: false }) orderFurniture: FurnitureListComponent;
  @ViewChild('engineSelect', { static: false }) engineSelect: MatSelect;

  @ViewChild('importModelInput', { static: true }) importInput: ElementRef;
  @ViewChild('modelFileInput', { static: true }) fileInput: ElementRef;

  order: CuttingOrderDetail;
  question: CuttingOrderQuestion;
  sendingMessages: ChatMessage[] = [];

  get orderId(): number | 'new' {
    return this.orderDetailService.orderId;
  }

  startTabIndex = 1;
  noCheckedCutErrors = 0;
  orderSaving = false;

  allowedModelExt = ['.b3d', '.obl', '.fr3d', '.zbprj', '.shn'];
  allowedImportModelExt = ['.k3bz', '.xml'];

  groupMaterialDiscountTreeDialogRef: MatDialogRef<GroupMaterialDiscountTreeDialogComponent>;
  groupMaterialDiscount$: Observable<MatBaseGroupDiscount[]>;
  operationGroups$: Observable<ICustomResponse<CuttingMatBaseGroup[]>>;
  materialGroups$: Observable<CuttingMatBaseGroup[]>;
  order$: Observable<CuttingOrderDetail>;
  loading$: Observable<boolean>;

  public promoCode: UntypedFormControl = new UntypedFormControl('', [
    Validators.maxLength(50),
    Validators.minLength(6),
    Validators.required,
  ]);

  tariffOptions: ICustomResponse<string[]>;
  question$: Observable<CuttingOrderQuestion>;
  unsubscribe$: Subject<void> = new Subject();
  addOrderToRemoteCart$: Observable<ICustomResponse<AddOrderToRemoteCartResponse>>;
  markAsRead$: Observable<void>;

  thisOrderStatusActions = OrderStatusAction;
  hubConnection: HubConnection | undefined;
  hubConnected = false;
  materialsValid = true;

  availabilityPaySystems: CuttingPaySystemInfo[] = [];
  psbPayDialogRef: MatDialogRef<PsbPayDialogComponent>;
  payPalPayDialogRef: MatDialogRef<PaypalPayDialogComponent>;
  wooppayPayDialogRef: MatDialogRef<WooppayPayDialogComponent>;
  addOrderToRemoteCartDialogRef: MatDialogRef<AddToRemoteCartResDialogComponent>;

  hasMaterialsDiscount = false;
  hasOperationsDiscount = false;

  pointsOfIssueDialogRef: MatDialogRef<PointsOfIssueDialogComponent>;

  noteDialogRef: MatDialogRef<OrderRemarkDialogComponent>;

  availableModelHoleDiameters$: Observable<ICustomResponse<CuttingHoleDiameters>>;

  deliveryAddressControl = new UntypedFormControl('', [Validators.required, MyValidator.autocompleteObjectValidator()]);
  addressResponse$: Observable<ExtendedAddress[]>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveDeliveryAddress$: Observable<any>;

  isRussian = true;
  userLang = 'en';

  showModelWriteSettings = false;

  cuttingSettings$: Observable<CuttingSettings>;
  cuttingSettings: CuttingSettings;
  clientOptions: CuttingClientOptions;

  settingsSyncDate$: Observable<ICustomResponse<CuttingFileSettingsSyncDate>>;
  markQuestionsAsRead$: Observable<void>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cuttingEnd$: Observable<[any, CuttingTask[], Estimate, [number, number, string]]>;

  presetSettings: PresetSettings;

  questionTabName = $localize`Задать вопрос`;
  unreadedCount = 0;
  selectedAddress: ExtendedAddress;
  lastSavedAddress: ExtendedAddress;

  get isShowPanelList(): boolean {
    return this.presetSettings.componentsAvailability.orderDetail.panelList;
  }

  get isShowQuestionList(): boolean {
    return (
      this.orderId !== 'new' && !this.order.archived && this.presetSettings.componentsAvailability.orderDetail.questions
    );
  }

  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    public orderDetailService: OrderDetailService,
    public location: Location,
    private router: Router,
    private snackBar: MatSnackBar,
    private eventManagerService: EventManagerService,
    public dialog: MatDialog,
    private paymentsService: PaymentsService,
    private clientMaterialService: ClientMaterialService,
    private dialogs: LegacyDialogsService,
    private userSettingsService: UserSettingsService,
    private clientOptionsService: ClientOptionService,
    private materialBaseService: MaterialBaseService,
    private injector: Injector,
    private orderQuestionChatService: OrderQuestionChatService
  ) {
    this.loadOrderInfo();

    this.settingsSyncDate$ = this.orderDetailService.getSettingsFilesSyncDate();

    this.isRussian = +LocalStorageManager.client.countryCode === 643;
    this.userLang = LocalStorageManager.client.languageCode;
    this.showModelWriteSettings = !!AuthHelper.getClientFromToken(LocalStorageManager.client.token.access)
      ?.ownerManagerId;

    this.question$ = this.order$.pipe(
      switchMap(order =>
        order?.questionId ? this.orderQuestionChatService.getQuestion(this.order.questionId) : of(null)
      ),
      tap(questionResponse => {
        if (questionResponse) {
          this.getUnreadedMessagesCount();
          this.questionTabName = $localize`Чат с менеджером`;
          this.question = questionResponse;
        } else {
          this.orderDetailService.onQuestionChanged.next(null);
          this.orderDetailService.onMessagesChanged.next(null);
          this.questionTabName = $localize`Задать вопрос`;
        }
      })
    );

    this.availableModelHoleDiameters$ = this.orderDetailService.getAvailableModelHolesDiams();

    this.cuttingEnd$ = this.orderDetailService.onEndCutting.pipe(
      skip(1),
      concatMap(res =>
        forkJoin([
          this.orderDetailService.getOrder(),
          this.orderDetailService.getCutHistory(),
          from(this.orderDetailService.getOrderEstimate()),
          of(res),
        ])
      ),
      tap(res => {
        if (res[3][0] === 0) {
          this.order.status.action = OrderStatusAction.CuttingCompleted;

          let resultMsg = '';
          if (this.cuttingSettings.estimateSettings.showItemsPriceBeforeVerified) {
            resultMsg = $localize`Раскрой завершен. Примерная стоимость: ${res[3][1].toFixed(2)}`;
          } else {
            resultMsg = $localize`Раскрой завершен.`;
          }

          if (res[2]?.AdditionalOperations?.length) {
            resultMsg += '. ' + $localize`Доступны дополнительные услуги`;
          }

          this.snackBar.open(resultMsg, undefined, { duration: 10000 });

          if (this.isOnlyFacadesInOrder()) {
            this.tabGroup.selectedIndex = this.tabGroup.selectedIndex + this.orderEstimateTab.position;
          } else {
            this.tabGroup.selectedIndex = this.tabGroup.selectedIndex + this.cuttingResultTab.position;
          }
        } else {
          this.snackBar.open($localize`Не удалось выполнить раскрой: (${res[3][2]})`, 'OK', { duration: 30000 });
        }
      }),
      finalize(() => (this.order.cuttingProccess = false))
    );

    iconRegistry.addSvgIcon(
      'paypal',
      sanitizer.bypassSecurityTrustResourceUrl('./assets/images/logos/payment-system/paypal.svg')
    );
    iconRegistry.addSvgIcon(
      'card',
      sanitizer.bypassSecurityTrustResourceUrl('./assets/images/logos/payment-system/mastercard.svg')
    );
    iconRegistry.addSvgIcon(
      'invoice',
      sanitizer.bypassSecurityTrustResourceUrl('./assets/images/logos/payment-system/invoice.svg')
    );
    iconRegistry.addSvgIcon(
      'wooppay',
      sanitizer.bypassSecurityTrustResourceUrl('./assets/images/logos/payment-system/wooppay.svg')
    );
  }

  getUnreadedMessagesCount(): void {
    this.orderQuestionChatService
      .getUnreadedMessagesCount(this.order.questionId)
      .pipe(
        tap(count => (this.unreadedCount = count)),
        takeUntil(this.unsubscribe$)
      )
      .subscribe();
  }

  ngAfterViewInit(): void {
    if (!_.isNaN(+this.orderId)) {
      this.connectToHub(+this.orderId);
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (this.editableOrder) {
      if (
        (event.keyCode === DOWN_ARROW || event.keyCode === INSERT) &&
        this.tabGroup.selectedIndex === this.tabGroup.selectedIndex + this.materialsTab.position
      ) {
        this.eventManagerService.addCuttingPanelEmitter$.next();
      }
    }
  }

  get editableOrder(): boolean {
    return (
      !this.order.archived &&
      (this.order.status.action === OrderStatusAction.Create ||
        this.order.status.action === OrderStatusAction.CuttingCompleted)
    );
  }

  hasBazisReading(tariffOptions: string[]): boolean {
    return tariffOptions.indexOf('BAZIS_MODELS') !== -1;
  }

  hasImport(tariffOptions: string[]): boolean {
    return tariffOptions.indexOf('IMPORT') !== -1;
  }

  isOnlyFacadesInOrder(): boolean {
    return (
      this.facadesComponent &&
      this.facadesComponent.panels?.length &&
      !this.isNotEmptyMaterials() &&
      _.isEmpty(this.orderDetailService.onCadModelsChanged.value) &&
      (_.isNil(this.orderFurniture) || _.isEmpty(this.orderFurniture.dataSource.data)) &&
      this.orderProductList &&
      !this.orderProductList.hasProducts()
    );
  }

  disableNotPaidSettings(tariffOptions: string[], presetSettings: PresetSettings): PresetSettings {
    const availability = _.cloneDeep(presetSettings);

    if (_.isNil(tariffOptions)) {
      availability.componentsAvailability.outlineEditor.angles = false;
      availability.componentsAvailability.outlineEditor.fasteners = false;
      availability.componentsAvailability.outlineEditor.slots = false;

      return availability;
    }

    if (!tariffOptions.includes('ADDITIONAL_PROCESSING')) {
      availability.componentsAvailability.outlineEditor.angles = false;
      availability.componentsAvailability.outlineEditor.slots = false;
    }

    if (!tariffOptions.includes('HOLES')) {
      availability.componentsAvailability.outlineEditor.fasteners = false;
    }

    this.disableNotPaidCountertopSettings(tariffOptions, availability);
    this.disableNotPaidFacadeSettings(tariffOptions, availability);

    return availability;
  }

  disableNotPaidCountertopSettings(tariffOptions: string[], presetSettings: PresetSettings): void {
    const availability = presetSettings.componentsAvailability.countertops;

    if (_.isNil(tariffOptions)) {
      availability.angleProcessing = false;
      availability.fasteners = false;
      availability.slots = false;
      availability.enabled = false;

      return;
    }

    if (!tariffOptions.includes('COUNTERTOPS')) {
      availability.enabled = false;
    }

    if (!tariffOptions.includes('ADDITIONAL_PROCESSING')) {
      availability.angleProcessing = false;
      availability.slots = false;
    }

    if (!tariffOptions.includes('HOLES')) {
      availability.fasteners = false;
    }
  }

  disableNotPaidFacadeSettings(tariffOptions: string[], presetSettings: PresetSettings): void {
    const availability = presetSettings.componentsAvailability.facades;

    if (_.isNil(tariffOptions)) {
      availability.angleProcessing = false;
      availability.fasteners = false;
      availability.slots = false;
      availability.enabled = false;

      return;
    }

    if (tariffOptions.indexOf('FACADES') === -1) {
      availability.enabled = false;
    }

    if (tariffOptions.indexOf('ADDITIONAL_PROCESSING') === -1) {
      availability.angleProcessing = false;
      availability.slots = false;
    }

    if (tariffOptions.indexOf('HOLES') === -1) {
      availability.fasteners = false;
    }
  }

  get showFurniture(): boolean {
    return this.presetSettings.componentsAvailability.orderDetail.furniture;
  }

  get showModels(): boolean {
    return this.presetSettings.componentsAvailability.orderDetail.models;
  }

  get showBCADModels(): boolean {
    return this.presetSettings.componentsAvailability.orderDetail.bCADModels;
  }

  get showProducts(): boolean {
    return this.presetSettings.componentsAvailability.orderDetail.products;
  }

  get showClientMaterials(): boolean {
    return this.presetSettings.componentsAvailability.orderDetail.clientMaterials;
  }

  get confirmedOrder(): boolean {
    return !this.editableOrder && this.order.status.action !== OrderStatusAction.Ordering;
  }

  async ngOnInit(): Promise<void> {
    this.clientMaterialService.resetMaterials();

    this.saveDeliveryAddress$ = this.deliveryAddressControl.valueChanges.pipe(
      filter(() => this.deliveryAddressControl.valid),
      tap(val => {
        if (!_.isNaN(+this.orderId)) {
          this.saveDeliveryAddress(val);
        }
      })
    );

    this.orderDetailService.onOrderChanged
      .pipe(
        first(order => !!order && !!order.deliveryAddress),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(order => {
        this.lastSavedAddress = order.deliveryAddress;
        this.selectedAddress = order.deliveryAddress;
        this.deliveryAddressControl.setValue(this.lastSavedAddress, { emitEvent: false });
      });

    this.addressResponse$ = this.deliveryAddressControl.valueChanges.pipe(
      filter(val => typeof val === 'string'),
      debounceTime(200),
      switchMap(val => this.getSuggestions(val)),
      catchError(() => {
        this.snackBar.open($localize`Ошибка загрузки подсказок`);

        return of([]);
      })
    );

    this.orderDetailService.onCutHistoryChanged
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response: CuttingTask[]) => {
        if (
          response.length > 0 &&
          response[0].stateCuttingTask === StateCuttingTaskEnum.Error &&
          !response[0].checkedByClient
        ) {
          let errCount = 0;

          _.each(response, item => {
            if (item.stateCuttingTask === StateCuttingTaskEnum.Error && !item.checkedByClient) {
              errCount++;
            }
          });

          this.noCheckedCutErrors = errCount;
        } else {
          this.noCheckedCutErrors = 0;
        }
      });

    // [ ] Необходимо Сделать переключение на Товары если нет материалов
    // go to models if has models and no materials
    // combineLatest([
    //   from(this.orderDetailService.onOrderChanged).pipe(take(1)),
    //   from(this.orderDetailService.onCadModelsChanged).pipe(take(1)),
    //   of(this.materialsComponent.materials),
    //   this.tariffOptions$.pipe(skip(1), take(1))
    // ])
    //   .pipe(takeUntil(this.unsubscribe$))
    //   .subscribe(opt => {
    //     if (
    //       opt[0] &&
    //       opt[1].length > 0 &&
    //       opt[2].length === 0 &&
    //       this.hasImportOrBazisReading(opt[3].result)
    //     ) {
    //       this.startTabIndex = 3;
    //     }
    //   });
  }

  checkDiscount(): void {
    if (!this.order) {
      return;
    }
    if (!this.order.discount) {
      return;
    }

    this.hasMaterialsDiscount = this.order.discount.materialDiscount?.some(v => v.discountPct);
    this.hasOperationsDiscount = this.order.discount.operationDiscount?.some(v => v.discountPct);
  }

  selectedTabChange(tab: MatTab): void {
    if (tab === this.cutHistoryTab && this.noCheckedCutErrors > 0) {
      this.orderDetailService.cutHistoryCheckAll();
    }

    if (tab === this.questionTab && this.orderDetailService.order.questionId > 0) {
      this.unreadedCount = 0;
    }
  }

  addFurniture(): void {
    this.orderFurniture.addFurniture(
      this.cuttingSettings.estimateSettings.showMaterialsPrice,
      this.cuttingSettings.showQuantityInStock
    );
  }

  blurDeliveryAddress(): void {
    // console.log(e);
    // if (!this.deliveryAddress.nativeElement.value) {
    //   this.order.deliveryAddress = undefined;
    // }
    // const controlValue = this.order.deliveryAddress ? this.order.deliveryAddress.value : '';
    // this.deliveryAddress.nativeElement.value = controlValue;
  }

  activatePromoCode(): void {
    this.orderDetailService
      .activatePromoCode(this.promoCode.value)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        () => {
          const snackText = $localize`Промокод активирован`;

          this.getOrder();
          this.orderDetailService.getOrderEstimate();

          this.snackBar.open(snackText, 'OK', { duration: 10000 });
        },
        (err: HttpErrorResponse) => {
          let errorText = '';

          switch (+err.status) {
            case 404:
              errorText = $localize`Промокод не найден`;
              break;

            case 403:
              errorText = $localize`Скидка на заказ уже применена. Применить промокод невозможно`;
              break;

            default:
              errorText = $localize`Промокод не был применён`;
          }

          this.snackBar.open(errorText);
        }
      );
  }

  openPointsOfIssueDialog(): void {
    const parentInjector = this.injector;

    this.pointsOfIssueDialogRef = this.dialog.open(PointsOfIssueDialogComponent, {
      panelClass: 'points-of-issue-dialog',
      disableClose: false,
      width: '1000px',
      injector: Injector.create({
        providers: [{ provide: OrderDetailService, useValue: parentInjector.get(OrderDetailService) }],
        parent: parentInjector,
      }),
    });

    this.pointsOfIssueDialogRef
      .afterClosed()
      .pipe(
        map((result: CuttingPointOfIssue[] | undefined) => (result && result.length > 0 ? result[0] : undefined)),
        filter(res => !_.isNil(res)),
        finalize(() => (this.pointsOfIssueDialogRef = null))
      )
      .subscribe(result => {
        this.order.pointOfIssue = result;

        if (!_.isNaN(+this.orderId)) {
          this.saveDeliveryPoint(this.order.pointOfIssue);
        }
      });
  }

  saveDeliveryType(deliveryType: DeliveryTypeEnum): Promise<void> {
    return new Promise((resolve, reject) => {
      this.orderDetailService
        .changeDeliveryType(deliveryType, this.order.id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          () => {
            this.orderDetailService.getOrder().subscribe(() => {
              this.orderDetailService.getOrderEstimate();
            });

            resolve();
          },
          () => {
            this.snackBar.open($localize`Не удалось сохранить заказ`);
            reject();
          }
        );
    });
  }

  saveDeliveryPoint(point: CuttingPointOfIssue): Promise<void> {
    return new Promise((resolve, reject) => {
      this.orderDetailService
        .changeDeliveryPoint(point, this.order.id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          () => {
            this.orderDetailService.getOrder().subscribe(() => {
              this.orderDetailService.getOrderEstimate();
            });

            resolve();
          },
          () => {
            this.snackBar.open($localize`Не удалось сохранить заказ`);
            reject();
          }
        );
    });
  }

  saveDeliveryAddress(deliveryAddress: ExtendedAddress): Promise<void> {
    return new Promise((resolve, reject) => {
      this.orderDetailService
        .changeDeliveryAddress(deliveryAddress, this.order.id)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          () => {
            this.orderDetailService.getOrder().subscribe(() => {
              this.orderDetailService.getOrderEstimate();
            });

            resolve();
          },
          () => {
            this.snackBar.open($localize`Не удалось сохранить заказ`);
            reject();
          }
        );
    });
  }

  addCadModelsAfterUpload(newCadModels: CuttingCadModel[]): void {
    newCadModels.forEach(newCadModel => {
      const modelIndex = this.orderDetailService.onCadModelsChanged.value.findIndex(x => x.guid === newCadModel.guid);
      if (modelIndex !== -1) {
        if (newCadModel.id === -1) {
          this.orderDetailService.onCadModelsChanged.value.splice(modelIndex, 1);
          this.orderDetailService.onCadModelsChanged.next(this.orderDetailService.onCadModelsChanged.value);
        } else {
          this.orderDetailService.onCadModelsChanged.value[modelIndex] = newCadModel;
        }
      } else {
        this.orderDetailService.onCadModelsChanged.value.unshift(newCadModel);
      }

      this.orderDetailService.onCadModelsChanged.next(this.orderDetailService.onCadModelsChanged.value);
    });
  }

  async checkCutterWorking(): Promise<boolean> {
    const isWorked: boolean = await this.hubConnection.invoke('IsCutterWorked', this.order.id);

    return isWorked;
  }

  async runCutting(): Promise<boolean> {
    if (!(await this.saveOrAddOrder())) {
      return false;
    }

    this.orderSaving = true;

    if (this.hasNotLinkedCadModels()) {
      this.snackBar.open($localize`Необходимо сопоставить материалы из моделей`);
      this.orderSaving = false;
      return false;
    }

    if (this.orderProductList && this.orderProductList.hasNoLinkedProducts()) {
      this.snackBar.open($localize`Необходимо сопоставить материалы в изделиях`, 'OK', { duration: 4000 });
      this.orderSaving = false;
      return false;
    }

    if (
      !this.isNotEmptyMaterials() &&
      _.isEmpty(this.orderDetailService.onCadModelsChanged.value) &&
      (_.isNil(this.orderFurniture) || _.isEmpty(this.orderFurniture.dataSource.data)) &&
      this.orderProductList &&
      !this.orderProductList.hasProducts() &&
      this.facadesComponent &&
      !this.facadesComponent?.panels?.length &&
      this.countertopsComponent &&
      !this.countertopsComponent?.countertops?.length
    ) {
      if (this.materialsComponent?.materials?.length) {
        this.snackBar.open($localize`Для добавленных материалов не заданы панели`);
      } else {
        this.snackBar.open($localize`В заказе отсутствуют материалы`);
      }

      this.orderSaving = false;
      return false;
    }

    if (
      this.isNotEmptyMaterials() ||
      !_.isEmpty(this.orderDetailService.onCadModelsChanged.value) ||
      (this.orderProductList && this.orderProductList.hasProducts()) ||
      (this.facadesComponent && this.facadesComponent?.panels?.length) ||
      (this.countertopsComponent && this.countertopsComponent?.countertops?.length)
    ) {
      this.order.cuttingProccess = true;
      this.hubConnection
        .invoke('RunCutting', this.order.id)
        .then((statusCode: number) => {
          this.orderSaving = false;
          if (+statusCode === 0) {
            this.order.cuttingProccess = true;
            console.log('Cutting started *_*');
          }
          if (+statusCode === 1) {
            this.snackBar.open($localize`Не удалось выполнить раскрой`);
            console.log('Cutting fail O_o');
          }
        })
        .catch(() => {
          this.order.cuttingProccess = false;
          this.snackBar.open($localize`Не удалось выполнить раскрой`);
          console.log('Cutting fail (Hub connection error) O_o');
        });
    } else {
      this.orderSaving = false;
      return true;
    }
  }

  async saveOrAddOrder(): Promise<boolean> {
    if (
      CornerProcessingHelper.possibilityCornerProcessing(
        this.materialsComponent?.materials,
        this.cuttingSettings.outlineEditorOptions
      )
    ) {
      this.snackBar.open($localize`Ошибка в обработке углов`);
      this.orderSaving = false;
      return false;
    }
    this.orderSaving = true;
    switch (_.isNaN(+this.orderId)) {
      case true:
        if (!(await this.addOrder())) {
          this.orderSaving = false;
          return false;
        }
        break;

      case false:
        if (!(await this.saveOrder())) {
          this.orderSaving = false;
          return false;
        }
        break;
    }

    this.orderSaving = false;
    return true;
  }

  orderingOrder(): void {
    this.orderDetailService.setOrderStatus(OrderStatusAction.Ordering);
  }

  confirmOrder(): void {
    this.orderDetailService.setOrderStatus(OrderStatusAction.Confirm);
  }

  isOrderFromOnlyDontCuttedItems(): boolean {
    let isOrderFromOnlyDontCuttedItems = false;
    if (
      this.order.id &&
      !this.materialsComponent?.materials?.length &&
      !this.facadesComponent?.panels?.length &&
      !this.countertopsComponent?.countertops?.length &&
      _.isEmpty(this.orderDetailService.onCadModelsChanged.value) &&
      this.orderFurniture?.dataSource?.data?.length > 0
    ) {
      isOrderFromOnlyDontCuttedItems = true;
      _.each(this.orderProductList?.dataSource?.data, p => {
        if (p.processingMode !== ProductProcessingMode.PriceList) {
          isOrderFromOnlyDontCuttedItems = false;
          return false;
        }
      });
    }
    return isOrderFromOnlyDontCuttedItems;
  }

  async addOrderForChildren(): Promise<void> {
    const addRes = await this.addOrder();

    if (addRes) {
      this.orderFiles?.orderSaved$.next(true);
      this.orderProductList?.orderSaved$.next(true);
      this.orderFurniture?.orderSaved$.next(true);
    } else {
      this.orderFiles?.orderSaved$.next(false);
      this.orderProductList?.orderSaved$.next(false);
      this.orderFurniture?.orderSaved$.next(false);
    }
  }

  async saveOrderAndDeleteCuttingResult(): Promise<void> {
    if (await this.saveOrder()) {
      this.cuttingResult.refreshData();
      this.orderDetailService.getOrderEstimate();
    }
  }

  async addOrder(): Promise<boolean> {
    if (this.materialsComponent) {
      this.materialsComponent.setMissingPanelPositions();

      await lastValueFrom(this.removeEmptyPanels());

      // validate materials
      const materials = this.materialsComponent.materials;
      const [validMaterials, materialsErrors] = this.validateMaterials(materials);
      if (!validMaterials) {
        this.snackBar.open(materialsErrors, 'OK', { duration: 10000 });
        return false;
      }
    }

    const ord: CuttingOrderDetail | undefined = await this.orderDetailService
      .addOrder(this.order)
      .catch(() => undefined);

    if (!ord) {
      return false;
    }

    this.order = new CuttingOrderDetail(ord);

    this.checkDiscount();

    await this.saveMaterialsAndFiles();

    await this.saveFacades();
    await this.saveCountertops();

    if (this.order.deliveryType) {
      await this.saveDeliveryType(this.order.deliveryType);

      if (this.order.deliveryType === DeliveryTypeEnum.Pickup) {
        await this.saveDeliveryPoint(this.order.pointOfIssue);
      }

      if (
        this.order.deliveryType === DeliveryTypeEnum.Courier &&
        this.deliveryAddressControl.valid &&
        this.deliveryAddressControl.value
      ) {
        await this.saveDeliveryAddress(this.deliveryAddressControl.value);
      }
    }

    if (this.orderFiles) {
      await Promise.all(
        Array.from(this.orderFiles.modified).map(e => firstValueFrom(this.orderDetailService.saveCadModel(e)))
      );
    }

    await lastValueFrom(this.clientMaterialService.saveClientMaterials(this.order.id));

    // Trigger the subscription with new data
    this.orderDetailService.onOrderChanged.next(this.order);
    this.orderDetailService.order = this.order;

    // Show the success message
    this.snackBar.open($localize`Заказ добавлен`);

    // Change the location with new one
    this.router.navigate(['order/detail/' + ord.id], { replaceUrl: true });
    await this.connectToHub(ord.id);

    return true;
  }

  changeOrderEngineWarning(): void {
    // this.dialogs.confirm($localize`При изменении движка раскроя, результаты раскроя будут удалены`)
    //   .pipe(takeUntil(this.unsubscribe$))
    //   .subscribe();
  }

  changeOrderEngine(engine: CuttingEngine): void {
    if (_.isNaN(+this.orderId)) {
      this.order.cuttingEngine = engine;
      return;
    }

    this.dialogs
      .confirm($localize`При изменении движка раскроя, результаты раскроя будут удалены. Продолжить?`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async res => {
        if (!res) {
          this.engineSelect.value = this.order.cuttingEngine;
          return;
        }

        const oldEngineValue = this.order.cuttingEngine;
        this.order.cuttingEngine = engine;

        this.orderSaving = true;

        if (!(await this.saveOrder())) {
          this.order.cuttingEngine = oldEngineValue;
          this.engineSelect.value = oldEngineValue;
          this.snackBar.open($localize`Не удалось сохранить заказ`);
        }

        this.orderSaving = false;
      });
  }

  validateMaterials(materials: CuttingMaterial[]): [boolean, string] {
    const [hasSame, samePosError] = this.checkSamePositions(materials);
    if (hasSame) {
      return [!hasSame, samePosError];
    }

    const [bigestPanels, panelSizeError] = this.checkPanelsParams(materials);
    if (bigestPanels) {
      return [!bigestPanels, panelSizeError];
    }

    const [crossHandAndFacadeMaterials, crossHandAndFacadeMaterialsError] =
      this.checkCrossHandAndFacadeMaterialAndCountertops(materials);
    if (crossHandAndFacadeMaterials) {
      return [!crossHandAndFacadeMaterials, crossHandAndFacadeMaterialsError];
    }

    return [true, ''];
  }

  checkCrossHandAndFacadeMaterialAndCountertops(materials: CuttingMaterial[]): [boolean, string] {
    if (!this.facadesComponent) {
      return [false, ''];
    }

    const intersection = (a, b): ICuttingBaseMaterial[] =>
      _.intersectionWith<ICuttingBaseMaterial, ICuttingBaseMaterial>(a, b, BazisMaterialHelper.compareMaterials);

    const crossMaterials = _.uniqWith(
      [
        ...intersection(materials, this.getFacadesTree()),
        ...intersection(materials, this.getCountertopsMaterials()),
        ...intersection(this.getFacadesTree(), this.getCountertopsMaterials()),
      ],
      BazisMaterialHelper.compareMaterials
    );

    if (!_.isEmpty(crossMaterials)) {
      const materialNames = crossMaterials
        .map(m => BazisMaterialHelper.formatMaterialNameAndArticle(m.name, m.article))
        .join(', ');

      return [
        true,
        $localize`Один и тот же материал не может одновременно использоваться в списке панелей, фасадах и столешницах. Пересечение в материалах: ${materialNames}`,
      ];
    }

    return [false, ''];
  }

  checkSamePositions(materials: CuttingMaterial[]): [boolean, string] {
    materials.forEach(m => {
      for (let j = 0; j < m.panels.length; j++) {
        const p = m.panels[j];
        for (let k = j + 1; k < m.panels.length; k++) {
          const p2 = m.panels[k];
          if (p.position === p2.position && p.position !== '') {
            return [
              true,
              $localize`В панелях материала "${BazisMaterialHelper.formatMaterialNameAndArticle(
                m.name,
                m.article
              )}" найдены одинаковые позиции (${p.position})`,
            ];
          }
        }
      }
    });
    return [false, ''];
  }

  checkPanelsParams(materials: CuttingMaterial[]): [boolean, string] {
    let errorFind = false;
    let message = '';

    materials.forEach(m => {
      if (errorFind) {
        return;
      }

      m.panels.forEach(p => {
        if (!this.canPanelFit(m.height, m.width, p)) {
          message = $localize`В материале "${BazisMaterialHelper.formatMaterialNameAndArticle(
            m.name,
            m.article
          )}" найдена панель, превышающая размеры плиты ${m.height}×${m.width}`;
          if (materials.length === 1) {
            message = $localize`Панель с позицией ${p.position} превышает размеры плиты ${m.height}×${m.width}`;
          }
          errorFind = true;
          return;
        }

        if (!this.checkPanelSize(p)) {
          message = $localize`В материале "${BazisMaterialHelper.formatMaterialNameAndArticle(
            m.name,
            m.article
          )}", панель с позицией ${p.position}, имеет некорректный размер ${p.height}×${p.width}`;

          if (materials.length === 1) {
            message = $localize`Панель с позицией ${p.position} имеет некорректный размер ${p.height}×${p.width}`;
          }
          errorFind = true;
          return;
        }

        if (!p.count || p.count < 1) {
          message = $localize`В материале "${BazisMaterialHelper.formatMaterialNameAndArticle(
            m.name,
            m.article
          )}", для панели с позицией ${
            p.position
          }, некорректно задано количество. Количество панелей должно быть больше нуля`;

          if (materials.length === 1) {
            message = $localize`Для панели с позицией ${p.position}, некорректно задано количество. Количество панелей должно быть больше нуля`;
          }
          errorFind = true;
          return;
        }
      });
    });

    return [errorFind, message];
  }

  checkPanelSize(panel: CuttingPanel): boolean {
    const options = this.cuttingSettings.panels;
    if (!options || options === null) {
      return true;
    }

    return CuttingPanelHelper.checkPanelSize(panel, options).valid;
  }

  canPanelFit(materialHeight: number, materialWidth: number, panel: CuttingPanel): boolean {
    const canFit = panel.height <= materialHeight || panel.width <= materialWidth;
    return panel.orientation ? canFit : canFit || panel.width <= materialHeight || panel.height <= materialWidth;
  }

  getAvailabilityPaySystem(payType: CuttingPaySystemType): CuttingPaySystemInfo {
    return this.availabilityPaySystems.find(w => w.systemType === payType);
  }

  openPayPalPayDialog(): void {
    const paySystem = this.getAvailabilityPaySystem(CuttingPaySystemType.PayPal);
    if (!paySystem) {
      return;
    }

    const sumOnPay = Math.round(this.order.amount);

    this.payPalPayDialogRef = this.dialog.open(PaypalPayDialogComponent, {
      panelClass: 'paypal-pay-dialog',
      disableClose: false,
      minWidth: '300px',
      maxWidth: '500px',
      minHeight: '600px',
      maxHeight: '1000px',
      data: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        commission_percent: paySystem.commissionPercentage,
        orderId: this.order.id,
        orderNumber: this.order.name,
        orderDate: this.order.dateCreate,
        amount: sumOnPay,
      },
    });

    this.payPalPayDialogRef.afterClosed().subscribe(() => {
      this.payPalPayDialogRef = null;
    });
  }

  openWooppayPayDialog(): void {
    const paySystem = this.getAvailabilityPaySystem(CuttingPaySystemType.Wooppay);
    if (!paySystem) {
      return;
    }

    const sumOnPay = Math.round(this.order.amount);

    this.wooppayPayDialogRef = this.dialog.open(WooppayPayDialogComponent, {
      panelClass: 'wooppay-pay-dialog',
      disableClose: false,
      minWidth: '300px',
      maxWidth: '500px',
      minHeight: '600px',
      maxHeight: '1000px',
      data: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        commission_percent: paySystem.commissionPercentage,
        orderId: this.order.id,
        orderNumber: this.order.name,
        orderDate: this.order.dateCreate,
        amount: sumOnPay,
      },
    });

    this.wooppayPayDialogRef.afterClosed().subscribe(() => {
      this.wooppayPayDialogRef = null;
    });
  }

  openPSBPayDialog(): void {
    const paySystem = this.getAvailabilityPaySystem(CuttingPaySystemType.Psb);
    if (!paySystem) {
      return;
    }

    const sumOnPay = Math.round(this.order.amount);

    this.psbPayDialogRef = this.dialog.open(PsbPayDialogComponent, {
      panelClass: 'psb-pay-dialog',
      disableClose: false,
      minWidth: '300px',
      maxWidth: '500px',
      minHeight: '600px',
      maxHeight: '1000px',
      data: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        commission_percent: paySystem.commissionPercentage,
        orderId: this.order.id,
        orderNumber: this.order.name,
        orderDate: this.order.dateCreate,
        amount: sumOnPay,
      },
    });

    this.psbPayDialogRef.afterClosed().subscribe(() => {
      this.psbPayDialogRef = null;
    });
  }

  openNodeEditDialog(): void {
    this.noteDialogRef = this.dialog.open(OrderRemarkDialogComponent, {
      panelClass: 'order-remark-dialog',
      disableClose: false,
      minWidth: '500px',
      maxWidth: '800px',
    });

    this.noteDialogRef.componentInstance.value = this.order.note;
    this.noteDialogRef.componentInstance.title = 'Примечание';

    this.noteDialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result !== undefined) {
        this.order.note = result;

        if (!_.isNaN(+this.orderId)) {
          this.orderDetailService
            .changeOrderNote(this.order.id, this.order.note)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(null, () => {
              this.snackBar.open($localize`Не удалось изменить примечание`);
            });
        }
      }
      this.noteDialogRef = null;
    });
  }

  openClientNodeEditDialog(): void {
    this.noteDialogRef = this.dialog.open(OrderRemarkDialogComponent, {
      panelClass: 'order-remark-dialog',
      disableClose: false,
      minWidth: '500px',
      maxWidth: '800px',
    });
    this.noteDialogRef.componentInstance.value = this.order.clientNote;
    this.noteDialogRef.componentInstance.title = $localize`Внутренний комментарий`;

    this.noteDialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result !== undefined) {
        this.order.clientNote = result;

        if (!_.isNaN(+this.orderId)) {
          this.orderDetailService
            .changeOrderClientNote(this.order.id, this.order.clientNote)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(null, () => {
              this.snackBar.open($localize`Не удалось изменить примечание`);
            });
        }
      }

      this.noteDialogRef = null;
    });
  }

  hasImportOrBazisReading(options: string[]): boolean {
    return options.indexOf('BAZIS_MODELS') !== -1 || options.indexOf('IMPORT') !== -1;
  }

  hasProductsTariffOptions(options: string[]): boolean {
    return options.indexOf('PRODUCTS') !== -1;
  }

  addToRemoteCart(): void {
    const linkToCart = this.cuttingSettings.cuttingOrderPaymentSettings.linkToCart;

    this.addOrderToRemoteCart$ = this.orderDetailService.addOrderToRemoteCart(linkToCart).pipe(
      tap(
        response => {
          if (response.result) {
            this.openAddOrderToRemoteCartDialog(response.result);
          }

          if (!response.result && response.error) {
            this.openAddOrderToRemoteCartDialog({
              errorText: JSON.stringify(response.error),
              status: 1,
              cartLink: '',
            });
          }
        },
        e => {
          this.openAddOrderToRemoteCartDialog({
            errorText: JSON.stringify(e),
            status: 1,
            cartLink: '',
          });
        }
      )
    );
  }

  openAddOrderToRemoteCartDialog(result: AddOrderToRemoteCartResponse): void {
    this.addOrderToRemoteCartDialogRef = this.dialog.open(AddToRemoteCartResDialogComponent, {
      panelClass: 'add-cutting-order-to-remote-cart-dialog',
      disableClose: false,
      minWidth: '500px',
      maxWidth: '800px',
    });

    this.addOrderToRemoteCartDialogRef.componentInstance.result = result;

    this.addOrderToRemoteCartDialogRef
      .afterClosed()
      .pipe(finalize(() => (this.addOrderToRemoteCartDialogRef = null)))
      .subscribe();
  }

  hasCustomPayment(): boolean {
    return this.cuttingSettings.cuttingOrderPaymentSettings.enable;
  }

  openAddElasticModelDialog(): void {
    this.orderProductList.openAddElasticModelDialog();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  onChangeModelsFileInput(event: any): void {
    this.orderFiles.onChangeFileInput(event);
  }

  holeDiamsList2String(val: number[]): string {
    return val.join(', ');
  }

  openGroupMaterialDiscountTreeDialog(): void {
    this.materialGroups$ = this.materialBaseService
      .getMatBaseMaterialGroups([TypeGroupMaterial.Linear, TypeGroupMaterial.Plate, TypeGroupMaterial.Butt])
      .pipe(
        tap(response => {
          this.groupMaterialDiscountTreeDialogRef = this.dialog.open(GroupMaterialDiscountTreeDialogComponent, {
            panelClass: 'group-material-discount-tree-dialog',
            disableClose: false,
            width: '700px',
          });

          this.groupMaterialDiscountTreeDialogRef.componentInstance.groups = response;
          this.groupMaterialDiscountTreeDialogRef.componentInstance.discounts = this.order.discount.materialDiscount;
          this.groupMaterialDiscountTreeDialogRef.componentInstance.readonly = true;

          this.groupMaterialDiscount$ = this.groupMaterialDiscountTreeDialogRef
            .afterClosed()
            .pipe(finalize(() => (this.groupMaterialDiscountTreeDialogRef = null)));
        })
      );
  }

  openGroupOperationDiscountTreeDialog(): void {
    this.operationGroups$ = this.materialBaseService.getMatBaseOperationGroups().pipe(
      filter(response => !!response.result),
      tap(response => {
        this.groupMaterialDiscountTreeDialogRef = this.dialog.open(GroupMaterialDiscountTreeDialogComponent, {
          panelClass: 'group-material-discount-tree-dialog',
          disableClose: false,
          width: '700px',
        });

        this.groupMaterialDiscountTreeDialogRef.componentInstance.groups = response.result;
        this.groupMaterialDiscountTreeDialogRef.componentInstance.discounts = this.order.discount.operationDiscount;
        this.groupMaterialDiscountTreeDialogRef.componentInstance.readonly = true;

        this.groupMaterialDiscount$ = this.groupMaterialDiscountTreeDialogRef
          .afterClosed()
          .pipe(finalize(() => (this.groupMaterialDiscountTreeDialogRef = null)));
      })
    );
  }

  updateSelectedAddress(address: ExtendedAddress): void {
    this.selectedAddress = address;
  }

  handleDeliveryAddressInput(): void {
    const value = this.deliveryAddressControl.value;

    if (typeof value !== 'string') {
      return;
    }

    if (value.trim() === '') {
      this.selectedAddress = null;
      this.deliveryAddressControl.setValue('', { emitEvent: false });
    } else if (this.selectedAddress) {
      if (value !== this.selectedAddress.unrestricted_value) {
        this.deliveryAddressControl.setValue(this.selectedAddress, { emitEvent: false });
      }
    } else {
      this.deliveryAddressControl.setValue(this.lastSavedAddress || '', { emitEvent: false });
    }
  }

  addressAutocompleteDisplayFn(val: ExtendedAddress): string {
    return val.unrestricted_value;
  }

  copyMaterialsChange(newMaterials: CuttingMaterial[]): void {
    this.materialsComponent.materials = newMaterials;
    this.materialsComponent.selectedMaterial = newMaterials[0];
  }

  async saveFacades(): Promise<any> {
    if (this.facadesComponent) {
      const materials = this.getFacadesTree();
      return firstValueFrom(this.orderDetailService.saveFacadeMaterials(materials, this.order.id));
    }
  }

  async saveCountertops(): Promise<void> {
    if (this.countertopsComponent) {
      const countertops = this.countertopsComponent.countertops;

      const request: CountertopRequest[] = mapBusinessObjectsToRequest(countertops);

      return firstValueFrom(this.orderDetailService.saveCountertops(request, this.order.id));
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();

    if (!_.isNaN(+this.orderId)) {
      this.hubConnection.stop();
    }
  }

  private getSuggestions(query: string): Observable<ExtendedAddress[]> {
    if (this.isRussian) {
      return this.orderDetailService.gatDadataAddressSuggestions(query) as Observable<ExtendedAddress[]>;
    } else {
      return this.getPlaceAutocomplete(query);
    }
  }

  private getPlaceAutocomplete(query: string): Observable<ExtendedAddress[]> {
    return this.orderDetailService.gatGoogleAddressSuggestions(query, this.userLang).pipe(
      map(res =>
        res.predictions.map(
          p =>
            ({
              data: null,
              googleData: p,
              value: p.description,
              // eslint-disable-next-line @typescript-eslint/naming-convention
              unrestricted_value: p.description,
            } as ExtendedAddress)
        )
      )
    );
  }

  private hasNotLinkedCadModels(): boolean {
    const cadModels = this.orderDetailService.onCadModelsChanged.value;

    for (const item of cadModels) {
      if (item.state !== LoadingState.MaterialReplaced) {
        return true;
      }
    }

    return false;
  }

  private isNotEmptyMaterials(): boolean {
    const materials = this.materialsComponent?.materials || [];

    if (materials.length === 0) {
      return false;
    }

    // If at least one material contains panels, then the materials have been validated.
    // If at least one material has the total number of panels equal to 0, then the panels have not been validated.
    // As a result, both panels and materials must pass validation.
    let validMaterials = false;
    for (const item of materials) {
      validMaterials = validMaterials || item.panels.length > 0;
    }

    return validMaterials;
  }

  private async saveMaterialsAndFiles(): Promise<void> {
    return new Promise((resolve, reject) => {
      const materials = _.cloneDeep(this.materialsComponent?.materials || []);

      Promise.all([
        firstValueFrom(this.orderDetailService.saveMaterials(materials, this.order.id)),
        firstValueFrom(this.materialsComponent?.syncOrderAttachments(this.order.id) ?? of(true)),
      ])
        .then(() => {
          this.snackBar.open($localize`Заказ сохранен`);
          resolve();
        })
        .catch(() => {
          this.snackBar.open($localize`Не удалось сохранить заказ`);
          reject();
        });
    });
  }

  private async saveOrder(): Promise<boolean> {
    if (this.materialsComponent) {
      this.materialsComponent.setMissingPanelPositions();

      await lastValueFrom(this.removeEmptyPanels());

      const materials = this.materialsComponent.materials;
      const [validMaterials, materialsErrors] = this.validateMaterials(materials);
      if (!validMaterials) {
        this.snackBar.open(materialsErrors, 'OK', { duration: 10000 });
        return false;
      }
    }

    if (this.orderProductList && this.orderProductList.hasNoLinkedProducts()) {
      this.snackBar.open($localize`Необходимо сопоставить материалы в изделиях`, 'OK', { duration: 4000 });
      return false;
    }

    try {
      await this.orderDetailService.saveOrder(this.order);
      await this.saveMaterialsAndFiles();

      await this.saveFacades();
      await this.saveCountertops();

      if (this.orderFiles) {
        await Promise.all(
          Array.from(this.orderFiles.modified).map(e => firstValueFrom(this.orderDetailService.saveCadModel(e)))
        );
      }

      await lastValueFrom(this.clientMaterialService.saveClientMaterials(this.order.id));
    } catch (err) {
      this.snackBar.open($localize`Не удалось сохранить заказ`);
      return false;
    }

    return true;
  }

  private getCountertopsMaterials(): CuttingMaterial[] {
    const materials = this.countertopsComponent?.countertops?.map(c => c.material) ?? [];

    return _.uniqWith(materials, BazisMaterialHelper.compareMaterials) as CuttingMaterial[];
  }

  private getFacadesTree(): CuttingFacadeMaterial[] {
    const facades = _.cloneDeep(this.facadesComponent.panels);

    const materials = _(facades)
      .groupBy(item => item.material.name + item.material.article)
      .map(g => {
        const material = g.find(p => p.material.id)?.material || g[0].material;

        material.facades = g.map(f => {
          delete f.material;
          return f as CuttingFacade;
        });

        return material;
      })
      .value();

    return materials;
  }

  private removeEmptyPanels(): Observable<boolean> {
    if (this.materialsComponent.hasEmptyPanels()) {
      return this.dialogs.confirm($localize`Пустые панели будут удалены. Продолжить?`).pipe(
        tap(r => {
          if (r) {
            this.materialsComponent.deleteEmptyPanels();
          }
        })
      );
    } else {
      return of(true);
    }
  }

  public sendMessage(message: ChatMessage): void {
    this.hubConnection.invoke('Send', this.order.questionId, message);
  }

  private async connectToHub(orderId: number): Promise<void> {
    const { connection, callback } = startConnection(ApiLinks.cuttingWorkerHub, {
      connectHandler: () => {
        connectToGroup(this.hubConnection, orderId, 'Connect');
      },
    });
    this.hubConnection = connection;

    await callback
      .then(() => {
        this.hubConnected = true;
        return this.checkCutterWorking();
      })
      .then(cuttingProcess => {
        this.order.cuttingProccess = cuttingProcess;
      })
      .catch(() => {
        this.hubConnected = false;
      });

    this.hubConnection.on('cuttingEnd', (amount: number, state: number, errorlog: string) => {
      this.orderDetailService.onEndCutting.next([+state, +amount, errorlog]);
    });

    this.hubConnection.on('ModelsUploadComplete', (models: CuttingCadModel[]) => {
      this.addCadModelsAfterUpload(models);
    });

    this.hubConnection.on('cadModelParsed', (parsedCadModel: CuttingCadModel, state: number, errorlog: string) => {
      const cadModel = this.orderDetailService.onCadModelsChanged.value.find(x => x.guid === parsedCadModel.guid);

      if (cadModel) {
        switch (+state) {
          case 0:
            cadModel.state = parsedCadModel.state;
            cadModel.draftBlocks = parsedCadModel.draftBlocks;
            cadModel.parsedMaterials = parsedCadModel.parsedMaterials;

            this.tabGroup.selectedIndex = this.tabGroup.selectedIndex + this.modelsTab.position;

            this.orderDetailService.onCadModelMaterialsParsed.next(cadModel);
            break;

          case 2:
            this.snackBar.open($localize`Файл зашифрован`);
            break;

          case 3:
            this.snackBar.open($localize`Файл сделан в нелицензионной версии модуля системы БАЗИС`);
            break;

          default:
            this.snackBar.open($localize`Не удалось прочитать модель (${errorlog})`);
            break;
        }

        // remove from list
        if (+state !== 0) {
          const index = this.orderDetailService.onCadModelsChanged.value.findIndex(x => x.guid === cadModel.guid);
          this.orderDetailService.onCadModelsChanged.value.splice(index, 1);
          this.orderDetailService.onCadModelsChanged.next(this.orderDetailService.onCadModelsChanged.value);
        }
      }
    });

    this.hubConnection.on(
      'cadModelConverted',
      (oldModelGuid: string, newModelGuid: string, state: number, errorlog: string) => {
        if (+state === 0) {
          this.getOrderFiles();
        } else {
          this.snackBar.open($localize`Не удалось конвертировать модель (${errorlog})`);

          const index = this.orderDetailService.onCadModelsChanged.value.findIndex(x => x.guid === oldModelGuid);
          this.orderDetailService.onCadModelsChanged.value.splice(index, 1);
          this.orderDetailService.onCadModelsChanged.next(this.orderDetailService.onCadModelsChanged.value);
        }
      }
    );

    this.hubConnection.on('cadModelReading', (modelGuid: string, state: number, errorlog: string) => {
      const cadModel = this.orderDetailService.onCadModelsChanged.value.find(x => x.guid === modelGuid);

      if (!cadModel) {
        return;
      }

      if (+state === 0) {
        cadModel.state = LoadingState.MaterialReplaced;

        this.orderDetailService.onCadModelMaterialsReplaced.next(cadModel);
      } else {
        // remove from list
        _.remove(this.orderDetailService.onCadModelsChanged.value, x => x.guid === cadModel.guid);
        this.orderDetailService.onCadModelsChanged.next(this.orderDetailService.onCadModelsChanged.value);

        this.snackBar.open($localize`Не удалось изменить модель (${errorlog})`);
      }

      this.tabGroup.selectedIndex = this.tabGroup.selectedIndex + this.modelsTab.position;
    });
  }

  onModelMaterialsLinked(parsedMaterials: CuttingCadModelMaterialLink[]): void {
    this.getOrder();
    this.orderDetailService.getOrderEstimate();

    parsedMaterials
      .filter(m => m.materialType === CadModelMaterialType.Linear || m.materialType === CadModelMaterialType.Plate)
      .forEach(m => {
        this.clientMaterialService.updateMaterials('model', {
          article: m.linkedMaterialArticle,
          name: m.linkedMaterialName,
          inMaterialBaseId: m.linkedMaterialId,
          type: m.materialType === CadModelMaterialType.Linear ? MaterialType.Linear : MaterialType.Plate,
          preparedForDeletion: false,
          cuttings: [],
          id: 0,
        } as CuttingClientMaterial);
      });
  }

  onModelDeleted(parsedMaterials: CuttingCadModelMaterialLink[]): void {
    this.getOrder();
    this.orderDetailService.getOrderEstimate();

    parsedMaterials
      .filter(m => m.materialType === CadModelMaterialType.Linear || m.materialType === CadModelMaterialType.Plate)
      .forEach(m => {
        this.clientMaterialService.prepareForDeletion('model', m.linkedMaterialName, m.linkedMaterialArticle);
      });
  }

  private getPresetSettings(): void {
    this.userSettingsService
      .getPresetSettings()
      .pipe(
        takeUntil(this.unsubscribe$),
        concatMap(p => this.orderDetailService.getAvailableTariffOptions().pipe(map(t => [t, p] as const)))
      )
      .subscribe(([tariff, presetSettings]) => {
        this.tariffOptions = tariff;
        this.presetSettings = this.disableNotPaidSettings(tariff.result, presetSettings);
      });
  }

  private getOrder(): void {
    this.order$ = this.orderDetailService.getOrder().pipe(share());
  }

  private subscribeToLoadingOrder(): void {
    this.loading$ = this.order$.pipe(map(res => !res));
  }

  private updateOrderOnChanges(): void {
    this.orderDetailService.onOrderChanged.subscribe(order => {
      if (order.id > 0) {
        this.order = new CuttingOrderDetail(order);
        this.checkDiscount();
        this.paymentsService
          .getPaySystemsInfo() //
          .then((response: CuttingPaySystemInfo[]) => (this.availabilityPaySystems = response));

        if (order.deliveryAddress) {
          this.deliveryAddressControl.setValue(order.deliveryAddress, { emitEvent: false });
        }
      } else {
        this.order = new CuttingOrderDetail();
        this.order.name = this.orderDetailService.defaultOrderName;

        this.checkDiscount();

        this.order.status = {
          action: OrderStatusAction.Create,
          name: new DefaultCuttingOrderStatusNamePipe().transform(OrderStatusAction.Create),
          id: 0,
          color: '',
          enableEmailNotifyForClient: false,
          enableSMSNotifyForClient: false,
          enableEmailNotifyForUser: false,
          enableSMSNotifyForUser: false,
          isDefault: true,
        };
      }
    });
  }

  private getCuttingSettings(): void {
    this.cuttingSettings$ = this.userSettingsService.getCuttingSettings().pipe(
      share(),
      tap(res => {
        this.cuttingSettings = res;
      })
    );
  }

  private getClientOptions(): void {
    this.clientOptionsService
      .getClientOptions()
      .pipe(
        map(res => (this.clientOptions = res)),
        takeUntil(this.unsubscribe$)
      )
      .subscribe();
  }

  private getCutHistory(): void {
    this.orderDetailService.getCutHistory().pipe(takeUntil(this.unsubscribe$)).subscribe();
  }

  private getOrderFiles(): void {
    this.orderDetailService.getOrderFiles().pipe(takeUntil(this.unsubscribe$)).subscribe();
  }

  private loadOrderInfo(): void {
    this.getCuttingSettings();
    this.getPresetSettings();
    this.getOrder();
    this.updateOrderOnChanges();
    this.subscribeToLoadingOrder();
    this.getCutHistory();
    this.getOrderFiles();
    this.getClientOptions();
  }
}
